import * as React from 'react';

export interface TextFieldBaseProps extends Pick<React.InputHTMLAttributes<HTMLInputElement>,
  'aria-activedescendant' | 'aria-controls' | 'aria-errormessage' | 'aria-invalid' | 'aria-label' | 'aria-labelledby' | 'aria-valuemax' |
  'aria-valuemin' | 'aria-valuenow' | 'disabled' | 'id' | 'maxLength' | 'name' | 'readOnly' | 'role'> {

  /** The overriding style of the div container */
  containerStyle?: React.CSSProperties;

  /** Method that is called when the user clicks away from the text field */
  handleBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;

  /** Method that is called when input changes with the value of the input.
   * `isComposing` is true when the user is in the middle of an IME composition activity. */
  handleChange?: (value: string, isComposing: boolean) => void;

  /** Method that is called when the user presses the enter key */
  handleEnter?: () => void;

  /** Method that is called when the user presses the escape key */
  handleEscape?: () => void;

  inputRef?: (ref: HTMLInputElement | null) => void;

  /** The overriding style of the input tag */
  inputStyle?: React.CSSProperties;

  onDarkBackground?: boolean;

  /** Text displayed to prompt the user when the `<input>` is empty. */
  placeholder?: string;

  /**
   * Should the text be selected when focused.
   * @default ```true```
   */
  shouldSelectTextOnFocus?: boolean;

  testId: string;

  /** The value inside the input */
  text?: string;

  /** Enum TextInputType that's value is either TextInputType.Text or TextInputType.Password */
  type?: TextInputType;
}

export enum TextInputType {
  Text = 'text',
  Password = 'password',
}
